import { useEffect, useMemo, useRef } from 'react';
import { matchPath, useLocation, useParams } from 'react-router';
import { useTrackPageImpression } from '../use-track-page-impression';
import { paths } from '../../utils';
import { useBuilding } from 'app/shared/contexts/building';
import { useUser } from 'app/shared/contexts/user';
import { useSdkHostInfo } from 'app/shared/hooks/use-sdk-host-info';
import { HOST_PLATFORMS } from 'app/shared/consts';

export const usePageImpressions = () => {
  const previousPageRef = useRef<string | null>(null);
  const trackImpression = useTrackPageImpression();
  const location = useLocation();
  const { building } = useBuilding();
  const buildingUuid = building?.uuid ?? '';
  const userDetails = useUser();
  const userUuid = userDetails?.user?.uuid ?? '';
  const { hostPlatform, hostInfo } = useSdkHostInfo();

  const params = useParams<Record<string, string>>();
  const matchedPath = useMemo(
    () => [paths].flat().find((pattern) => matchPath(pattern, location.pathname)),
    [location.pathname],
  );

  const platform = useMemo(() => {
    if (!hostInfo) return undefined;

    return hostPlatform ?? HOST_PLATFORMS.MOBILE;
  }, [hostInfo, hostPlatform]);

  useEffect(() => {
    if (!platform || !userUuid) return;

    const resolvedRoute = location.pathname;
    if (previousPageRef.current === resolvedRoute) return;
    previousPageRef.current = resolvedRoute;

    trackImpression({
      route: matchedPath ?? location.pathname,
      slugs: { ...(params as Record<string, string>), building_uuid: buildingUuid, host_platform: platform },
      resolved_route: location.pathname,
    });
  }, [location.pathname, params, matchedPath, trackImpression, buildingUuid, userUuid, platform]);
};
